import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './SearchBar.scss';
var SearchBar = function (_a) {
    var onClick = _a.onClick, isActive = _a.isActive, isDywVersion = _a.isDywVersion, isSearchModalShown = _a.isSearchModalShown, className = _a.className, openSearchModal = _a.openSearchModal;
    var t = useTranslation().t;
    var handleSearchButtonClick = function () {
        var isSearchPage = location.pathname.startsWith('/search');
        if (!isSearchPage) {
            if (!isSearchModalShown) {
                openSearchModal();
            }
        }
        else {
            onClick && onClick();
        }
    };
    return (React.createElement("div", { className: classnames(s['searchbar-container'], isDywVersion && s['dyw-version'], className) },
        React.createElement(PlainButtonOrLink, { biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'search',
            }, className: classnames('ignore-react-onclickoutside', s['icon-button-searchbar']), onClick: handleSearchButtonClick, "aria-label": t('siteHeader.search.a11y.openSearchDialog') },
            React.createElement(SearchIcon, { className: classnames(s['search-icon'], isActive && s['active']), size: IconSize.MEDIUM, disableDefaultColors: true }),
            React.createElement("span", { className: classnames(s['search-label'], isActive && s['active']) }, t(isDywVersion
                ? 'siteHeader.searchBar.dywVersion'
                : 'siteHeader.searchBar')))));
};
SearchBar.displayName = 'SearchBar';
export default SearchBar;
//# sourceMappingURL=SearchBar.js.map